import styled from 'styled-components';
import Modal from 'react-modal';
import Countdown, { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import SecondsCounter from './SecondsCounter';
import images from '../../../images';
import clockIcon from '../../../images/Clock.png';

const Container = styled.div`
  visibility: hidden;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 35px;
`;

const CountDownContainer = styled.div`
  position: fixed;
  display: flex;
  top: 0%;
  right: 6%;
  flex-direction: row;
`;

const TimerImage = styled.img`
  height: 6.66vw;
  width: 6.66vw;
  margin-top: 30%;
  scale: 0.7;
  margin-left: 5%;
`;

const CloseButton = styled.img`
  height: 5vw;
  width: 5vw;
  border-radius: 50%;
  position: fixed;
  top: 2.8%;
  left: 6%;
`;

const TopContainer = styled.div`
  position: fixed;
  display: flex;
  top: 3%;
  justify-content: space-between;
  flex-direction: row;
`;

const ModalImages = styled.div`
  visibility: visible;
  position: fixed;
  display: flex;
  top: 33.33vh;
  right: 12.5vw;
  text-align: center;
  justify-content: space-between;
`;

const MaterialDetails = styled.div`
  overflow-y: hidden;
  position: fixed;
  width: 85%;
  overflow-x: hidden;
  height: 62.5vh;
  padding: 5px;
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 85%;
  max-height: 62.5vh;
  will-change: transform;
  border-radius: 10px;
  box-shadow:
  2px 2px 10px 2px rgba(0, 0, 0, 0.2);
`;

const MaterialImage = styled.img`
  height: 40vh;
  width: 90%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const MaterialName = styled.h2`
  text-align: center;
  font-size: 3.33vh;
  margin-top: 5%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 1%;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  transform: translate(50%, -50%);
`;

const CountDownBeginning = styled.div`
  position: fixed;
  display: flex;
  top: 30%;
  right: 30%;
`;

// Renderer callback with condition
const renderer = ({ seconds }) => <SecondsCounter seconds={zeroPad(seconds)} isBeforeGame />;

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '95%',
    height: '100%',
    borderRadius: 15,
    border: 'none',
    backgroundColor: 'rgba(0,0,0,.0001)'
  }
};

/**
 * This component shows a 8 seconds count down timer before starting of the game
 * wrong or correct asnwers.
 *
 */

const CountDownModal = (
  {
    questionIndex,
    currentLevel,
    modalVisible,
    doneMaterials,
    passedMaterialsCount,
    onClose,
    recycleRightData
  }
) => {
  const modalIsOpen = true;

  const ButtonRecycable = styled.img`
    visibility: 'hidden';
    height: 7vh;
    width: 7vh;
    border-radius: 50%;
    background-color: #efefef;
    background-size: contain;
    background-position: center;
    margin: 0 auto;
  `;

  const ButtonNotRecycable = styled.img`
    visibility: 'hidden';
    height: 7vh;
    width: 7vh;
    border-radius: 50%;
    background-color: #efefef;
    background-size: contain;
    background-position: center;
    margin: 0 auto;
  `;

  const CountDownRectangle = styled.div`
    position: fixed;
    /* top: ${(Number(window.innerHeight / window.innerWidth) > 1.6) ? 2.2 : 3}%; */
    top: ${(Number(window.innerHeight / window.innerWidth) * -1.875 + 6.375)}%;
    right: 4.5%;
    height: 4.5vh;
    width: 20vw;
    background-color: #48802A;
    border-radius: 4vw;
  `;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      overlayClassName="signup-modal-overlay"
    >
      <Container>
        <ModalImages>
          <CountDownBeginning>
            <Countdown date={Date.now() + 5000} renderer={renderer} />
          </CountDownBeginning>
        </ModalImages>
        <TopContainer>
          <CloseButton role="button" tabIndex={0} src={images.close} alt="Close" />
          <CountDownRectangle />
          <CountDownContainer>
            <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} />
            <TimerImage
              src={clockIcon}
              alt="Timer"
            />
          </CountDownContainer>
        </TopContainer>
        <Levels
          levels={recycleRightData}
          currentLevel={currentLevel}
          modalVisible={modalVisible}
        />
        <>
          <CardContainer>
            <MaterialDetails>
              <MaterialImage
                src={recycleRightData[currentLevel][questionIndex].mat_image}
                alt={recycleRightData[currentLevel][questionIndex].mat_nm || 'Material image'}
              />
              <MaterialName>
                {recycleRightData[currentLevel][questionIndex].mat_nm}
              </MaterialName>
              <ButtonsContainer>
                <ButtonNotRecycable src={images.decline} alt="Not recyclable" />
                <ButtonRecycable src={images.recycable} alt="Recyclable" />
              </ButtonsContainer>
            </MaterialDetails>
          </CardContainer>
          <GameStatusIndicator
            totalMaterials={recycleRightData[currentLevel]}
            doneMaterials={doneMaterials}
            prevTotalMaterials={passedMaterialsCount}
          />
        </>
      </Container>
    </Modal>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.recycleRight.allRrData
  })
)(CountDownModal);
